/**
 * Created by Mikhail Menshenin on 26.08.2024
 */

const CrossView = cc.Node.extend({
    ctor: function (cross) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setVisible(cross.village.isStateRaid());
        this.cross = cross;
        this.clickAnimation = false;

        const styles = cleverapps.styles.CrossView;

        const icon = this.icon = new cleverapps.Spine(bundles.village.jsons.cross_json);
        icon._debugExclude = true;
        this.icon.setAnimation(0, "hover_back", false);
        icon.setAlignment(styles.icon);
        this.addChild(icon);
        icon.setVisible(!cross.raided);

        if (cross.raided) {
            const pit = this.pit = new cleverapps.Spine(bundles.village.jsons.dig_animation);
            pit.setAlignment(styles.pit);
            pit.setAnimation(0, "empty", false);
            this.addChild(pit);
        }

        cleverapps.UI.applyHover(this, {
            onMouseOver: this.onMouseOver.bind(this),
            onMouseOut: this.onMouseOut.bind(this)
        });

        const positions = styles.villages[cross.village.level] || styles.villages[cross.village.level % 2];
        const position = positions[cross.id];
        this.setContentSize2(icon.getContentSize());
        this.setAlignment(position);

        if (cross.raided) {
            this.animateDig();
        } else {
            this.show();
        }

        cleverapps.UI.onClick(this, this.onClick.bind(this), { interactiveScale: false });

        cross.on("dig", this.animateDig.bind(this), this);

        if (cleverapps.config.debugMode) {
            this.setVisible(cross.village.isStateRaid() || !!cleverapps.flags.villageCrossEnabled);
            cleverapps.flags.on("change:villageCrossEnabled", () => {
                this.setVisible(!!cleverapps.flags.villageCrossEnabled);
            });
        }
    },

    show: function () {
        if (!this.cross.village.isStateRaid()) {
            return;
        }

        this.setScale(0.1);
        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(1.7 + 0.2 * this.cross.id),
            new cc.Show(),
            new cc.CallFunc(() => {
                cleverapps.audio.playSound(bundles.main.urls.slot_target);
            }),
            cleverapps.UI.animateScale({
                duration: 0.1,
                scale: 1,
                overScaling: 1.2
            })
        ));
    },

    animateDig: function (cb) {
        const gold = this.cross.gold;
        const styles = cleverapps.styles.CrossView;
        const animation = gold === 0 ? "empty" : "gold";

        const pit = this.pit = new cleverapps.Spine(bundles.village.jsons.dig_animation);
        pit.setAlignment(styles.pit);
        this.addChild(pit);
        pit.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene(), {
            keepScale: true
        });
        pit.setLocalZOrder(4);

        this.icon.runAction(
            new cc.Sequence(
                new cc.PlaySound(bundles.main.urls.slot_raid_dig),
                new cc.CallFunc(() => this.pit.setAnimation(0, animation, false)),
                new cc.Hide(),
                new cc.DelayTime(this.pit.getAnimationDuration(animation) - 1),
                new cc.CallFunc(() => {
                    if (animation === "gold") {
                        cleverapps.audio.playSound(bundles.main.urls.fountain_coins);
                    }
                }),
                new cc.DelayTime(1),
                new cc.CallFunc(cb || (() => { }))
            )
        );
    },

    checkClick: function (touch) {
        if (this.cross.village.isStateRaid()) {
            const size = this.icon.getContentSize();
            const rect = cc.rect(0, 0, size.width, size.height);
            if (cc.rectContainsPoint(rect, this.icon.convertToNodeSpace(touch.getLocation())) || cc.rectContainsPoint(rect, this.icon.convertToNodeSpace(touch.getStartLocation()))) {
                this.cross.onClick();
                return true;
            }
        }
        return false;
    },

    onClick: function () {
        if (!this.cross.raided && !this.clickAnimation) {
            this.clickAnimation = true;
            if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
                this.icon.setAnimation(0, "click_vertical", false);
            } else {
                this.icon.setAnimation(0, "click_horizontal", false);
            }
            this.icon.setCompleteListener(() => {
                this.clickAnimation = false;
                this.icon.setCompleteListener();
                this.cross.onClick();
            });
        }
    },

    onMouseOver: function () {
        if (!this.cross.raided) {
            this.icon.setAnimation(0, "hover_forward", false);
        }
    },

    onMouseOut: function () {
        if (!this.cross.raided) {
            this.icon.setAnimation(0, "hover_back", false);
        }
    }
});

cleverapps.styles.CrossView = {
    scale: [1.6, 1, 1],

    pit: {
        x: { align: "center" },
        y: { align: "center", dy: 60 }
    },

    icon: {
        x: { align: "center" },
        y: { align: "center" }
    },

    villages: []
};